module.exports = __webpack_public_path__ + "img/icon2.bc3b47c9.png";